import { jsx as a, jsxs as t, Fragment as M } from "react/jsx-runtime";
import { useCallback as f, useState as y, useEffect as W } from "react";
import { createPortal as x } from "react-dom";
import e from "./styles.module.less.js";
import { MenuItem as B } from "../menu-item/index.js";
import A from "../close.svg.js";
import U from "../chevron-right.svg.js";
import $ from "../menu-dropdown-wrapper-mobile.svg.js";
import { useDisableScroll as q } from "../../../../utils/use-disable-scroll.js";
import { getRoute as T, RouteType as k } from "../../../../utils/get-route.js";
import { getChatUrl as h } from "../../../../utils/webapp-chat-url.js";
import L from "./get-help-ai-image.png.js";
import E from "./get-help-lawyer-image.png.js";
import { SlidingButton as u, SlidingButtonType as N } from "../../../general/sliding-button/index.js";
const ee = (g) => {
  var i;
  const {
    language: s,
    isActive: v,
    hasShrunk: n,
    titleLabel: o,
    getTranslation: r,
    isLawyerSupported: C = !1,
    onRequestLawyer: l,
    newChatUrl: d
  } = g, p = f(() => {
  }, []);
  return /* @__PURE__ */ a(
    B,
    {
      label: o ?? "",
      chevronStyle: "rotate",
      hasShrunk: n,
      isActive: v,
      onClick: p,
      classNames: {
        labelContainer: e.menuItemContainer,
        childContainer: e.menuItemDropdown
      },
      children: /* @__PURE__ */ a(
        "div",
        {
          className: `${e.innerWrapper} ${((i = g.classNames) == null ? void 0 : i.container) ?? ""}`,
          children: /* @__PURE__ */ t("div", { className: e.getHelpCardsContainer, children: [
            C && /* @__PURE__ */ t("div", { className: e.getHelpCard, children: [
              /* @__PURE__ */ t("div", { className: e.getHelpCardContent, children: [
                /* @__PURE__ */ a("h3", { className: e.getHelpCardTitle, children: r("pages.find-the-right-lawyer") }),
                /* @__PURE__ */ a("div", { className: e.getHelpCardCtaWrapper, children: /* @__PURE__ */ a(
                  u,
                  {
                    link: l ? void 0 : h({
                      origin: d,
                      language: s,
                      path: T(k.LAWYER_REQUEST_CHAT),
                      ref: "webapp-get-help-request-lawyer"
                    }),
                    onClick: (c) => {
                      l && (c == null || c.preventDefault(), l());
                    },
                    text: r("pages.request-a-lawyer"),
                    buttonType: N.PURPLE,
                    classNames: {
                      buttonContainer: e.getHelpCardButton
                    }
                  }
                ) })
              ] }),
              /* @__PURE__ */ a("div", { className: e.getHelpCardImageWrapper, children: /* @__PURE__ */ a(
                "img",
                {
                  src: E,
                  alt: "Find the right lawyer",
                  className: e.getHelpCardImage
                }
              ) })
            ] }),
            /* @__PURE__ */ t("div", { className: e.getHelpCard, children: [
              /* @__PURE__ */ t("div", { className: e.getHelpCardContent, children: [
                /* @__PURE__ */ a("h3", { className: e.getHelpCardTitle, children: r("pages.get-ai-legal-answers") }),
                /* @__PURE__ */ a("div", { className: e.getHelpCardCtaWrapper, children: /* @__PURE__ */ a(
                  u,
                  {
                    link: h({
                      origin: d,
                      language: s,
                      ref: "webapp-get-help-ask"
                    }),
                    text: r("pages.ask-a-question"),
                    buttonType: N.BLUE_MIDNIGHT,
                    classNames: {
                      buttonContainer: e.getHelpCardButton
                    }
                  }
                ) })
              ] }),
              /* @__PURE__ */ a("div", { className: e.getHelpCardImageWrapper, children: /* @__PURE__ */ a(
                "img",
                {
                  src: L,
                  alt: "Get AI legal answers",
                  className: e.getHelpCardImage
                }
              ) })
            ] })
          ] })
        }
      )
    }
  );
}, ae = (g) => {
  const {
    language: s,
    titleLabel: v,
    getTranslation: n,
    onRequestLawyer: o,
    newChatUrl: r,
    closeMenu: C,
    classNames: l,
    externalIsOpen: d,
    externalOnOpen: p,
    externalOnClose: i,
    hideDefaultTrigger: c = !1
  } = g, [S, b] = y(!1), [D, w] = y(!1), I = d !== void 0 ? d : S;
  q({ isDisabled: I });
  const R = f(() => {
    p ? p() : b(!0);
  }, [p]), m = f(() => {
    w(!0), setTimeout(() => {
      i ? i() : b(!1), w(!1), C();
    }, 150);
  }, [C, i]);
  return W(() => (window.addEventListener("resize", m), () => {
    window.removeEventListener("resize", m);
  }), [m]), /* @__PURE__ */ t(M, { children: [
    !c && /* @__PURE__ */ t("div", { className: e.headingContainer, onClick: R, children: [
      /* @__PURE__ */ a(
        "div",
        {
          className: `${e.mainMenuLink} ${(l == null ? void 0 : l.mainMenuLink) ?? ""}`,
          children: v
        }
      ),
      /* @__PURE__ */ a(U, { className: e.arrowIcon })
    ] }),
    I ? x(
      /* @__PURE__ */ t(
        "div",
        {
          className: `${e.areasMenuModal} ${l == null ? void 0 : l.container}`,
          children: [
            /* @__PURE__ */ a("div", { className: e.closeWrapper, children: /* @__PURE__ */ a(
              A,
              {
                className: `${e.closeButton} ${e.activeIcon} ${D ? e.hidden : ""}`,
                onClick: m
              }
            ) }),
            /* @__PURE__ */ a("div", { className: e.modalContent, children: /* @__PURE__ */ t("div", { className: e.getHelpCardsContainerMobile, children: [
              /* @__PURE__ */ a(M, { children: /* @__PURE__ */ t("div", { className: e.getHelpCardMobile, children: [
                /* @__PURE__ */ t("div", { className: e.getHelpCardContentMobile, children: [
                  /* @__PURE__ */ a("h3", { className: e.getHelpCardTitleMobile, children: n("pages.find-the-right-lawyer") }),
                  /* @__PURE__ */ a("div", { className: e.getHelpCardCtaWrapper, children: /* @__PURE__ */ a(
                    u,
                    {
                      link: o ? void 0 : h({
                        origin: r,
                        language: s,
                        path: T(k.LAWYER_REQUEST_CHAT),
                        ref: "webapp-get-help-request-lawyer"
                      }),
                      onClick: (H) => {
                        o && (H == null || H.preventDefault(), o()), m();
                      },
                      text: n("pages.request-a-lawyer"),
                      buttonType: N.PURPLE,
                      classNames: {
                        buttonContainer: e.getHelpCardButton
                      }
                    }
                  ) })
                ] }),
                /* @__PURE__ */ a(
                  "img",
                  {
                    src: E,
                    alt: "Find the right lawyer",
                    className: e.getHelpCardImageMobile
                  }
                )
              ] }) }),
              /* @__PURE__ */ t("div", { className: e.getHelpCardMobile, children: [
                /* @__PURE__ */ t("div", { className: e.getHelpCardContentMobile, children: [
                  /* @__PURE__ */ a("h3", { className: e.getHelpCardTitleMobile, children: n("pages.get-ai-legal-answers") }),
                  /* @__PURE__ */ a("div", { className: e.getHelpCardCtaWrapper, children: /* @__PURE__ */ a(
                    u,
                    {
                      link: h({
                        origin: r,
                        language: s,
                        ref: "webapp-get-help-ask"
                      }),
                      text: n("pages.ask-a-question"),
                      buttonType: N.BLUE_MIDNIGHT,
                      classNames: {
                        buttonContainer: e.getHelpCardButton
                      }
                    }
                  ) })
                ] }),
                /* @__PURE__ */ a(
                  "img",
                  {
                    src: L,
                    alt: "Get AI legal answers",
                    className: e.getHelpCardImageMobile
                  }
                )
              ] })
            ] }) }),
            /* @__PURE__ */ a($, { className: e.mobileBGIcon })
          ]
        }
      ),
      document.body
    ) : null
  ] });
};
export {
  ee as GetHelpMenuItemDesktop,
  ae as GetHelpMenuItemMobile
};
